import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Badge } from "reactstrap";
import { toast } from "react-toastify";
import { getAmenitiesApi, deleteAmenityApi, toggleAmenityStatusApi, restoreAmenityApi, } from "../../apiServices/projectServices";
import AppLoader from "../Common/AppLoader";

const AmenitiesTable = ({ search, tab, refresh, setMode, setSelected, setModal, }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await getAmenitiesApi({
        search,
        status: tab,
      });

      setData(res?.data || []);
    } catch {
      toast.error("Failed to fetch");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search, refresh, tab]);

  const handleDelete = async (id) => {
    await deleteAmenityApi(id);
    toast.warning("Deleted Amenity");
    fetchData();
  };

  const handleStatus = async (id, current) => {
    await toggleAmenityStatusApi(id, !current);
    toast.success("Updated Status");
    fetchData();
  };

  const handleRestore = async (id) => {
    await restoreAmenityApi(id);
    toast.success("Restored Amenity");
    fetchData();
  };

  if (loading) return <AppLoader />;

  return (
    <div className="table-responsive">
      <Table className="table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, i) => (
            <tr key={item._id}>
              <td>{i + 1}</td>
              <td>{item.name}</td>

              <td>
                <Badge color={item.isActive ? "success" : "dark"}>
                  {item.isActive ? "Active" : "Inactive"}
                </Badge>
              </td>

              <td>
                {tab !== "deleted" && (
                  <div className="d-flex gap-3 align-items-center">
                    <i
                      className="mdi mdi-pencil text-primary cursor-pointer fs-4"
                      onClick={() => {
                        setMode("edit");
                        setSelected(item);
                        setModal(true);
                      }}
                    />

                    <div className="d-flex align-items-center">
                      <input
                        id={`amenity-status-${item._id}`}
                        type="checkbox"
                        switch="primary"
                        checked={item.isActive}
                        onChange={() =>
                          handleStatus(item._id, item.isActive)
                        }
                      />
                      <label
                        htmlFor={`amenity-status-${item._id}`}
                        data-on-label=""
                        data-off-label=""
                        className="mb-0"
                      />
                    </div>

                    <i
                      className="mdi mdi-delete text-danger cursor-pointer fs-4"
                      onClick={() => handleDelete(item._id)}
                    />
                  </div>
                )}

                {tab === "deleted" && (
                 <i className="mdi mdi-backup-restore text-success cursor-pointer fs-4" onClick={() => handleRestore(item._id)} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AmenitiesTable;